import React, { useState, useEffect } from "react";

import "./Prizes.css";
import prizesImage from "../../assets/Prizes.png";
import Navbar from "../../components/Navbar/Navbar";
import Form from "../../components/Form/Form";
import gen from "../../assets/gen1.png";
import cash from "../../assets/cash_1.png";
import data from "../../assets/data_1.png";


import gen_2 from "../../assets/gen_2.png";
import cash_2 from "../../assets/cash_2.png";
import airtime_2 from "../../assets/airtime_2.png";
import prizes_spinner from "../../assets/prizes_spinner.png";
import { Redirect, useHistory } from "react-router-dom";

function GetWindowDimensions() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return width;
}

const Prizes = () => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const slideImages = [gen_2, cash_2, airtime_2];
  const [currentImg, setCurrentImg] = useState(cash_2);

  const onClick = (e) =>{
    // setInterval(() => {
      setCurrentImg(
        slideImages[Math.floor(Math.random() * slideImages.length)]
      );
    // }, 5000);
  }

  // useEffect(() => {
  //   setInterval(() => {
  //     setCurrentImg(
  //       slideImages[Math.floor(Math.random() * slideImages.length)]
  //     );
  //   }, 5000);
  //   // return () => window.removeEventListener('resize', handleResize);
  // }, [setInterval]);

  if (localStorage.getItem('authed')=='authenticated') {
    return <Redirect to="/play" />;
  }

  const checkNext = () => {
    const labels = document.querySelectorAll("#slider label");
    const nextIndex =
      selectedIndex === labels.length - 1 ? 0 : selectedIndex + 1;
    setSelectedIndex(nextIndex);
  };

  const check = (index) => setSelectedIndex(index);
  const width = GetWindowDimensions();
  return (
    <div className="container">
      <Navbar />
      {width >= 1223 ? (
        <div className="row">
          <div className="col-sm-12 col-md-4 order-1 order-sm-2 ">
            <div className="">
              <h2 className="header-text mt-5">AMAZING PRIZES</h2>
              {/* <h2 className="header-text">AMAZING PRIZES</h2> */}
              <br></br>
            </div>
            {/* <h6 className="text-white mt-5">
              Enter your number below and spin the wheel to be our next lucky
              winner
            </h6>
            <Form /> */}
            <div class="list-group text-center">
              <a href="#" class="list-group-item list-group-item-action active">PRIZES TO BE WON</a>
              <a href="#" class="list-group-item list-group-item-action">Generator</a>
              <a href="#" class="list-group-item list-group-item-action disabled">Camry </a>
              <a href="#" class="list-group-item list-group-item-action disabled">Airtime </a>
              <a href="#" class="list-group-item list-group-item-action disabled">Lots of Cash </a>
            </div>
          </div>

          <div className="order-sm-12 col-md-8">
            <div class="containers mt-5 pt-5">
              <div class="spinner">
                <img src={prizes_spinner}></img>
              </div>
              <div class="slider-content">
                <div class="item">
                  <div class="image-simul">
                    <img src={gen}></img>
                  </div>
                  <p>A Generator Instant prize</p>
                </div>
                <div class="item">
                  <div class="image-simul">
                    <img src={cash}></img>
                  </div>
                  <p> Instant Cash prizes</p>
                </div>
                <div class="item">
                  <div class="data-image">
                    <img src={data}></img>
                  </div>
                  <p>Instant Airtime Prizes</p>
                </div>
              </div>
              {/* <button onClick={checkNext}>{'>'}</button> */}
            </div>
          </div>
        </div>
      ) : (
        
        <div className="row">
          <div className="col-md-6 offset-md-3">
            <div className="text-center ">
              <div class="spinner pt-5">
                <img style={{maxHeight: "200px",
                    minHeight: "150px",   maxWidth: "200px",minWidth: "150px"}} src={prizes_spinner}></img>
              </div>
              <div class="item">
                <div class="slider-content">
                  <img
                    className="second mb-2 pb-2 "
                    src={currentImg}
                    alt="Logo"
                    onClick={onClick}
                    style={{maxHeight: "600px",
                    minHeight: "400px",   maxWidth: "600px",minWidth: "400px"}}
                  />
                </div>
              </div>
            </div>

            <div className="container">
              <h2 className="header-text-mobile text-center">
                {" "}
                SPIN TO WIN AMAZING PRIZES
              </h2>
              {/* <h2 className="header-text">AMAZING PRIZES</h2> */}
              <br></br>
            </div>
            <h6 className="text-white mt-5">
              Enter your number below and spin the wheel to be our next lucky
              winner
            </h6>
            <Form />
          </div>
        </div>
      )}
    </div>
  );
};

export default Prizes;
